module.exports = __webpack_public_path__ + "static/media/oberflex-ormedamerique-2560x1440.5f93af29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-ormedamerique-2560x1440.jpg
// module id = 1047
// module chunks = 37